"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSolanaErrorCode = exports.createSolanaTransactionFromBase64 = void 0;
const web3_js_1 = require("@solana/web3.js");
const createSolanaTransactionFromBase64 = (partiallySignedTx) => web3_js_1.Transaction.from(Buffer.from(partiallySignedTx, 'base64'));
exports.createSolanaTransactionFromBase64 = createSolanaTransactionFromBase64;
const getFirstRegExpGroup = (regexp, str) => {
    const match = str.match(regexp);
    return match && match.length > 0 ? match[0] : undefined;
};
const parseSolanaErrorCode = (message) => {
    return getFirstRegExpGroup(/0[xX][0-9a-fA-F]+/gi, message);
};
exports.parseSolanaErrorCode = parseSolanaErrorCode;
